import(/* webpackMode: "eager", webpackExports: ["CannyShell"] */ "/app/src/components/canny/CannyShell.tsx");
